import { ReactNode } from 'react'

import { TourPlacementEnum, TourStep } from '../types/model-tour'

export interface TourStepInput {
  id: string
  content: ReactNode
  title?: ReactNode
  placement?: TourPlacementEnum
  spotlightPadding?: number
  when?: boolean
}

export const buildTourSteps = (inputs: ReadonlyArray<TourStepInput>): TourStep[] =>
  inputs.filter((step) => step.when !== false).map(({ id, when, ...rest }) => ({ target: `#${id}`, ...rest }))
